import { render, staticRenderFns } from "./rollback-modal.vue?vue&type=template&id=d80a3546&scoped=true&"
import script from "./rollback-modal.vue?vue&type=script&lang=ts&"
export * from "./rollback-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d80a3546",
  null
  
)

export default component.exports